import styles from './Header.module.scss';
import { LogoLight, LogoDark } from '../../../assets/icons';
import  { HeaderVariant, type THeaderVariant } from './types';
import { NavLink } from 'react-router-dom';


interface HeaderProps {
  variant: THeaderVariant;
}

const Header = ({ variant }: HeaderProps) => {
  const variants: Record<THeaderVariant, { borderBottom: string; background: string; logo: typeof LogoLight | typeof LogoDark }> = {
    [HeaderVariant.Brown30BlackWhiteLogo]: {
      borderBottom: '1px solid #000',
      background: 'rgba(139, 83, 59, 0.30)',
      logo: LogoLight,
    },
    [HeaderVariant.White20WhiteWhiteLogo]: {
      borderBottom: '1px solid #FFF',
      background: 'rgba(255, 255, 255, 0.20)',
      logo: LogoLight,
    },
    [HeaderVariant.Brown20BlackWhiteLogo]: {
      borderBottom: '1px solid #000',
      background: 'rgba(139, 83, 59, 0.20)',
      logo: LogoLight,
    },
    [HeaderVariant.Brown20NoneWhiteLogo]: {
      borderBottom: 'none',
      background: 'rgba(139, 83, 59, 0.20)',
      logo: LogoLight,
    },
    [HeaderVariant.Brown20BlackDarkLogo]: {
      borderBottom: '1px solid #000',
      background: 'rgba(139, 83, 59, 0.20)',
      logo: LogoDark,
    },
  };

  const config = variants[variant];

  const headerStyle = {
    borderBottom: config.borderBottom,
    background: config.background,
  };

  const LogoComponent = config.logo;

  return (
    <header className={styles.header} style={headerStyle}>
      <NavLink to="/"> <LogoComponent className={styles.logo} width={152} height={30} /></NavLink>
    </header>
  );
};

export default Header;